import { render, staticRenderFns } from "./RecetasComponent.vue?vue&type=template&id=44254606&"
import script from "./RecetasComponent.vue?vue&type=script&lang=js&"
export * from "./RecetasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports